import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { clearGdpr } from '../actions/gdprActions';
import GdprView from '../components/pages/GDPR/GdprView';

class GdprViewContainer extends Component {
  render() {
    return <GdprView {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    gdpr: state.gdpr
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    removeGdpr() {
      dispatch(clearGdpr());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GdprViewContainer);



// WEBPACK FOOTER //
// ./src/containers/GdprViewContainer.jsx